// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import WebApiService from './plugins/WebApiService'

/* eslint-disable no-new */
/* eslint-disable indent */
Vue.use(VueResource)
Vue.use(WebApiService)

new Vue({
    el: '#app',
    router,
    components: { App },
    // FIX: Here use of template would violate CSP (content-security-policy) header - use render function instead.
    // $$$ template: '<App />'
    render: function (createElement) {
        return createElement(App)
    }
})



// WEBPACK FOOTER //
// ./src/main.js